
/**
 * 프로젝트 통계 정보
 */
export type ProjectListResponsePageAllOfThreeContentItemStatsInfo = {
  /** 인용 수 */
  citationCount?: number;
  /** 좋아요 수 */
  likeCount?: number;
  /** 댓글(답글) 수 */
  replyCount?: number;
  /** 조회수 */
  viewCount?: number;
};
